import { custom, labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      isOwnerOccupier: Joi.boolean(),
      isInvestment: Joi.boolean()
    })
    .orValue('isOwnerOccupier', 'isInvestment')
    .label(labeled(label, 'Loan purpose type'));

export default {
  schema
};
